// extracted by mini-css-extract-plugin
export var alt = "ParagraphPageIntro-module--alt--8028d";
export var container = "ParagraphPageIntro-module--container--561ea";
export var desktopOnly = "ParagraphPageIntro-module--desktopOnly--3583f";
export var main = "ParagraphPageIntro-module--main--614fc";
export var mobileOnly = "ParagraphPageIntro-module--mobileOnly--35eeb";
export var textLeft = "ParagraphPageIntro-module--textLeft--fac1f";
export var visuallyHidden = "ParagraphPageIntro-module--visuallyHidden--84995";